import { jsxs, jsx } from 'react/jsx-runtime';
import '../ui/alert.js';
import '@radix-ui/react-avatar';
import 'date-fns-tz';
import { cn } from '../../utils/formatters.js';
import '@radix-ui/react-label';
import '../ui/button.js';
import '@radix-ui/react-progress';
import '@clerk/clerk-react';
import 'lucide-react';
import 'react';
import '../../lib/toast.js';
import 'react-router-dom';
import '../../contexts/AppContext.js';
import '../../contexts/OrganizationContext.js';
import 'axios';
import '@tanstack/react-query';
import '../page-layout/FormPageLayout.js';
import { Card, CardHeader, CardTitle, CardDescription, CardContent } from '../ui/card.js';
import 'cmdk';
import '@radix-ui/react-dialog';
import '@radix-ui/react-popover';
import './RichTextEditor.js';
import '@radix-ui/react-switch';
import '../crud/CrudDetailView.js';
import '../crud/CrudFormView.js';
import '../../contexts/SidebarContext.js';
import '../../contexts/ThemeContext.js';
import '@dnd-kit/core';
import '@dnd-kit/sortable';
import '@dnd-kit/utilities';
import '../ui/badge.js';
import 'react-day-picker';
import '../ui/chart.js';
import '@radix-ui/react-checkbox';
import '@radix-ui/react-collapsible';
import 'vaul';
import '@radix-ui/react-dropdown-menu';
import '../ui/radio-group.js';
import '@radix-ui/react-select';
import '../ui/time-input.js';
import '@radix-ui/react-separator';
import '../ui/sidebar.js';
import 'react-toastify';
import '@radix-ui/react-tabs';
import '@radix-ui/react-tooltip';

/**
 * Standard form-section card: a `rounded-xl` card with a bordered header band
 * (title + optional description) and a padded content area. This is the canonical
 * "card with a specific style header" used across the app's forms (amenity form,
 * CrudFormView-driven forms, etc.) so every form section looks identical.
 *
 * @param title - Section heading rendered in the header band.
 * @param description - Optional sub-heading under the title.
 * @param headerActions - Optional right-aligned header content.
 * @param children - Section content (form fields).
 * @param className - Extra classes for the card root.
 * @param contentClassName - Extra classes for the content area (after `p-6`).
 */
function FormSectionCard({ title, description, headerActions, children, className, contentClassName, }) {
    const hasHeader = title != null || description != null || headerActions != null;
    return (jsxs(Card, { className: cn('rounded-xl border bg-card shadow-sm gap-0 py-0', className), children: [hasHeader && (
            // `[.border-b]:pb-4` overrides shadcn CardHeader's default `[.border-b]:pb-6`,
            // which otherwise leaves extra bottom padding under bordered section headers.
            jsx(CardHeader, { className: "px-6 py-4 border-b [.border-b]:pb-4", children: jsxs("div", { className: "flex items-start justify-between gap-4", children: [jsxs("div", { className: "space-y-1", children: [title != null && jsx(CardTitle, { className: "text-zinc-900", children: title }), description != null && jsx(CardDescription, { children: description })] }), headerActions != null && (jsx("div", { className: "flex items-center gap-2", children: headerActions }))] }) })), jsx(CardContent, { className: cn('p-6', contentClassName), children: children })] }));
}

export { FormSectionCard };
//# sourceMappingURL=FormSectionCard.js.map
